import { createFileRoute, Outlet } from "@tanstack/react-router";
import Layout from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/(tabs)/layout";
import TabsError from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/(tabs)/components/TabsError";
import NotFound from "@/components/NotFound";

export const Route = createFileRoute(
  "/$tenantId/$messengerId/$hostConfig/_launcherLayout/$locale/_localeLayout/_tabsLayout",
)({
  component: Component,
  errorComponent: ErrorComponent,
  notFoundComponent: NotFound,
});
function Component() {
  const params = Route.useParams();

  return (
    <Layout params={params}>
      <Outlet />
    </Layout>
  );
}

function ErrorComponent({ error, reset }: { error: unknown; reset: () => void }) {
  const params = Route.useParams();
  return <TabsError error={error} reset={reset} params={params} />;
}
